import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";

/**
 * DedupeApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/dedupeApi/dedupeApi.service.js.
 *
 * Posts a list of normalized customer payloads against the dedupe endpoint
 * (`/v2/api/customers/pos/customerswithduplicates`) and returns possible
 * duplicates. Accepts either a single membershipCard or an array.
 */
const DEDUPE_BASE_V2 = "/v2/api/customers/pos/customerswithduplicates";

interface MembershipCardAddress {
  streetAddress1?: string;
  streetAddress2?: string;
  city?: string;
  state?: string;
  country?: string;
}

interface MembershipCardLike {
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  address: MembershipCardAddress;
}

@Injectable({ providedIn: "root" })
export class DedupeApiService {
  private readonly http = inject(HttpClient);

  list(
    membershipCards: MembershipCardLike | MembershipCardLike[],
  ): Promise<AjsResponse<unknown>> {
    const cards = Array.isArray(membershipCards)
      ? membershipCards
      : [membershipCards];
    const customers = cards.map((card) => ({
      firstName: card.firstName,
      middleName: card.middleName,
      lastName: card.lastName,
      email: card.email,
      phone: card.phone,
      address: [
        {
          type: "primary",
          streetAddress1: card.address.streetAddress1,
          streetAddress2: card.address.streetAddress2,
          city: card.address.city,
          state: card.address.state,
          country: card.address.country,
        },
      ],
    }));
    return wrapAjs(this.http.post<unknown>(DEDUPE_BASE_V2, { customers }));
  }
}
